<section class="sm:min-h-[25.6rem] min-h-[40rem] sm:h-[36.6rem] px-[2rem] overflow-hidden max-sm:max-w-[80vw] max-sm:max-h-[80vh] max-sm:px-[6rem] max-sm:py-[3rem]  flex items-center justify-center bg-white"
  [ngClass]="data.isHtml ? 'sm:w-[71rem]' : 'sm:w-[51.2rem]'" role="dialog" aria-modal="true" aria-labelledby="message-title">
  <div class="flex flex-col justify-between w-full h-[80%] ">
    <mat-dialog-content >
      <div class="!max-h-none !m-0 !p-0 overflow-y-auto flex h-full w-full" [ngClass]="data.isHtml ? 'items-start justify-start text-left' : 'items-center justify-center text-center'" role="document">
        @if(data.isHtml) {
          <div id="message-title" class="notification-html-content dsr-typescale-body-medium w-full !leading-[24px] text-justify" [innerHTML]="safeMessage"></div>
        } @else {
          <p id="message-title" class="dsr-typescale-body-medium text-center w-full">{{data.message}}</p>
        }
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="!min-h-fit !m-0 !p-0 flex !font-[600] items-center h-fit justify-center pt-4">
      <button mat-flat-button class="" (click)="closeDialog()" type="button" aria-label="Close message">
        <span class="">OK</span>
      </button>
    </mat-dialog-actions>
  </div>
</section>